<template>
  <div v-if="voucherSet.length > 0">
    <carousel
      autoplay
      centerMode
      :perPageCustom="[[0, 1], [800, 2]]"
      :loop="true"
      :paginationEnabled=false
      :autoplayTimeout="4000"
    >
      <slide
        v-for="(voucher, index) in voucherSet"
        :key="index"
        @slideclick="showPromotion(voucher)"
      >
        <img
          :src="voucher.image"
          style="width: 100%; height: auto;"
        />
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'

export default {
  components: {
    'carousel': Carousel,
    'slide': Slide
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'guestId'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('voucher', [
      'vouchers', 'allVouchers', 'promotionVoucher'
    ]),
    ...mapGetters('cart', [
      'cart'
    ]),
    voucherSet () {
      return this.isMember ? this.vouchers.filter(v => (v.used === null && !v.gems_member_voucher.UnlimitedUse) || v.gems_member_voucher.UnlimitedUse === 1) : this.allVouchers
      // display guest voucher
      // if (this.isMember) {
      //   return this.vouchers.filter(v => (v.used === null && !v.gems_member_voucher.UnlimitedUse) || v.gems_member_voucher.UnlimitedUse === 1)
      // }
      // if (!this.isMember && this.vouchers.length > 0) {
      //   return this.vouchers.filter(v => (v.member_id === this.guestId))
      // }
      // return this.allVouchers
    }
  },
  methods: {
    async showPromotion (voucher) {
      // VoucherType = 2 means that this is a display-only voucher
      if (parseInt(voucher.VoucherType) === 2) {
        return
      }
      if (this.isMember) {
        await this.$store.dispatch('voucher/fetchMyVouchers')
      // if (this.isMember || voucher.member_id === this.guestId) {
      //   if (this.isMember) await this.$store.dispatch('voucher/fetchMyVouchers')
        if (this.vouchers.findIndex(c => parseInt(c.voucher_id) === parseInt(voucher.voucher_id)) === -1) {
          const text = 'This voucher is fully redeemed or expired. Please reload the page to only show available vouchers.'
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'This voucher is fully redeemed or expired',
            text: text,
            modal: true,
            buttons: [
              { text: 'Ok' }
            ]
          })
          return
        }
        if (parseInt(voucher.gems_member_voucher.VoucherType) === 0) {
          this.$store.dispatch('responseMessage', {
            type: 'info',
            text: this.$t('info_apply_voucher_checkout')
          })
        } else if (voucher.gems_member_voucher.PLUID && voucher.item) {
          if (voucher.item.has_courses) {
            this.$bus.$emit('showFullLoading', true)
            await this.$store.dispatch('menu/fetchCatItems', voucher.item.category_id)
            this.$bus.$emit('showFullLoading', false)
          }
          await this.$store.dispatch('voucher/setPromotionVoucher', voucher)
          if (voucher.item.has_courses) {
            if (this.cart.find(item => item.voucher_id === this.promotionVoucher.voucher_id)) {
              const text = 'You already used this voucher in your basket.'
              this.$store.dispatch('responseMessage', {
                type: 'error',
                title: 'One redemption per member',
                text: text,
                modal: true
              })
              return
            } else {
              this.$store.dispatch('voucher/showVoucherItemDialog', this.menuItem)
            }
          } else {
            this.$store.dispatch('voucher/showPromotionDialog')
          }
          if (this.iOS && this.inIframe) {
            this.$router.push({ name: 'promotion', params: { return: 'menu' }})
          }
        } else {
          this.$store.dispatch('responseMessage', {
            type: 'info',
            text: 'The voucher item is not ready yet.'
          })
        }
      } else {
        const text = 'You need to have an account to redeem the voucher. Please sign in your account or register one if you do not have it yet.'
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Please sign in or register',
          text: text,
          modal: true,
          buttons: [
            { text: 'Cancel' },
            { text: 'Sign in', path: 'login', color: 'button1a' },
            { text: 'Register', path: 'register', color: 'button2' }
          ]
        })
      }
    }
  },
  async created () {
    if (this.isMember) {
      await this.$store.dispatch('voucher/fetchMyVouchers')
    } else {
      await this.$store.dispatch('voucher/fetchAllVouchers')
      // await this.$store.dispatch('voucher/fetchGuestVouchers')
    }
    // await this.$store.dispatch('member/fetchMemberCats')
    // await this.$store.dispatch('member/fetchMemberItems')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PromotionDiv.vue